import { useGetBadgesWithUserStatus } from '../../Hooks/useBadgeHooks';
import BadgeDisplay from './BadgeDisplay';
import './BadgeList.scss';

interface BadgeListProps {
	userId?: number;
}

const BadgeList = ({ userId }: BadgeListProps) => {
	const { badges, statusState } = useGetBadgesWithUserStatus(userId);

	if (statusState === 'LOADING') {
		return <div className='biz-badge-list__loading'>Loading badges...</div>;
	}

	if (statusState === 'ERROR') {
		return <div className='biz-badge-list__error'>Failed to load badges.</div>;
	}

	if (!badges || badges.length === 0) {
		return <div className='biz-badge-list__empty'>No badges available yet.</div>;
	}

	// Separate earned and unearned badges
	const earnedBadges = badges.filter((b) => b.UserHasEarned);
	const unearnedBadges = badges.filter((b) => !b.UserHasEarned);

	return (
		<div className='biz-badge-list'>
			{earnedBadges.length > 0 && (
				<div className='biz-badge-list__section'>
					<h3 className='biz-badge-list__section-title'>Earned Badges ({earnedBadges.length})</h3>
					<div className='biz-badge-list__grid'>
						{earnedBadges.map((badge) => (
							<BadgeDisplay key={badge.Id} badge={badge} />
						))}
					</div>
				</div>
			)}

			{unearnedBadges.length > 0 && (
				<div className='biz-badge-list__section'>
					<h3 className='biz-badge-list__section-title'>Available Badges ({unearnedBadges.length})</h3>
					<div className='biz-badge-list__grid'>
						{unearnedBadges.map((badge) => (
							<BadgeDisplay key={badge.Id} badge={badge} />
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default BadgeList;
